export default "/_next/static/images/dylan-allread-7bfc82fcb73356ed7c8219e4a6e574e7.png";